import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../atoms/Icon'
import SydButton from '../../../commonDesign/Button'
import { useFilterSelectContext } from './context'
import { FilterMenu } from './FilterMenu'

export const FilterToggle = ({
  size = 'sm',
  children,
  iconProps = { name: 'filters' },
  filterTypeSelectProps,
  resetButton,
  noFilterText = 'No filters selected'
}) => {
  const {
    selectedValues,
    setShowDetails,
    showDetails,
    maxShow,
    selectedText,
    moreText
  } = useFilterSelectContext()

  const selectedDisplay = useMemo(() => {
    if (!selectedValues?.length) return noFilterText
    if (selectedValues.length <= maxShow) {
      return selectedText + selectedValues
        .map(({ label }) => label.length > 18 ? `${label.slice(0, 18)}...` : label)
        ?.join(', ')
    }
    return `${selectedValues?.length} ${moreText}`
  }, [selectedValues, noFilterText, maxShow, moreText, selectedText])

  const anchorRef = useRef(null)

  return (
    <>
      <div ref={anchorRef}>
        <SydButton size={size} onClick={() => setShowDetails(!showDetails)}>
          <div className='flex gap-2 items-center'>
            <Icon {...iconProps} />
            {selectedDisplay}
          </div>
        </SydButton>
      </div>

      <FilterMenu
        anchorRef={anchorRef}
        filterTypeSelectProps={filterTypeSelectProps}
        resetButton={resetButton}
      >
        {children}
      </FilterMenu>
    </>
  )
}

FilterToggle.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'lg']),
  resetButton: PropTypes.shape({
    enable: PropTypes.bool,
    text: PropTypes.string
  }),
  iconProps: PropTypes.object,
  filterTypeSelectProps: PropTypes.object,
  noFilterText: PropTypes.string,
  children: PropTypes.node
}
